<div class="flex items-center gap-4">
    <div class="flex items-center !gap-2 w-[30%]">
        <input
            type="checkbox"
            [checked]="isChecked()"
            [disabled]="readonly() || isDisabled()"
            (change)="onCheckboxChange($event)"
            class="form-check-input checked:!bg-bold-green"
        />
        <label class="text-sm font-medium">{{ label() | translate }}</label>
    </div>
    <div class="w-[70%]">
        <input
            type="text"
            [formControl]="inputControl"
            [placeholder]="placeholder() | translate"
            [disabled]="!isChecked() || readonly() || isDisabled()"
            [readOnly]="readonly()"
            (input)="onInputChange()"
            class="form-control"
        />
    </div>
</div>
